import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { graphql } from '../../../../../gql';
import { useApiMutation } from '../../../../../query/hooks';
import { mutationResponseHandler } from '../../../../../utils/mutationResponseHandler';
import { determineArrayUpdateOperation } from '../../../../../utils/determineArrayUpdateOperation';
import { TagsSelect } from '../../../../../form/TagsSelect';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';
import { useSnackbar } from '../../../../../store/snackbar';

const updateActivityMutation = graphql(`
	mutation tagsCell_updateActivityMutation($activityId: UUID!, $data: ActivityUpdateInput!) {
		updateActivity(by: { id: $activityId }, data: $data) {
			ok
			errorMessage
		}
	}
`);

export const TagsCell: FC<WidgetProps> = ({ activityId, activityName, widget: { tags } }) => {
	const intl = useIntl();
	const [showAddTag, setShowAddTag] = useState(false);
	const { openSnackbar } = useSnackbar();

	const { mutate: updateActivity } = useApiMutation(updateActivityMutation, {
		onSuccess: (result) => {
			mutationResponseHandler({
				result: result.updateActivity.ok,
				toastMessages: {
					error: intl.formatMessage({ id: 'journey.detail.widget.tags.update.error' }),
				},
				errorMessage: result.updateActivity.errorMessage,
				openSnackbar,
			});
		},
	});

	const tagIds = tags.map((tag) => tag.id);

	const handleChangeTags = (newTags: readonly string[]) => {
		const tagsOperations = determineArrayUpdateOperation(tagIds, newTags);
		// Prevent firing empty update mutation
		if (tagsOperations.length === 0) {
			return;
		}

		updateActivity({ activityId, data: { tags: tagsOperations } });
	};

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.tags.type}
			onMouseEnter={() => setShowAddTag(true)}
			onMouseLeave={() => setShowAddTag(false)}
		>
			<Stack spacing={1.5} height={'inherit'}>
				<TagsSelect value={tagIds} onChange={handleChangeTags} hideAdd={!showAddTag} size={'small'} />
			</Stack>
		</WidgetCell>
	);
};
